import { PlayerStates } from '../../types/common';

export interface IPlayerStateChangeListener {
  onStateChange: (state: PlayerStates) => void
}

export class YtUtils {
  public static stateChangeListeners: IPlayerStateChangeListener[] = [];
}
